import { render } from "./ViewAll.vue?vue&type=template&id=61fc4bc4"
import script from "./ViewAll.vue?vue&type=script&lang=js"
export * from "./ViewAll.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__